import React, {useContext, useState} from 'react';
import {useHttp} from "../../../../hooks/http.hook";
import {AuthContext} from '../../../../context/AuthContext'

import validator from "../../../../hooks/validator.hook";
import FormInput from "../../../../components/Inputs/FormInput/FormInput";

import '../../../General/AuthPage/sass/AuthPage.sass'
import {Link} from "react-router-dom";
import Modal from "../../../../components/Modal";
import OrganizationAuthForm from "../../../General/AuthPage/OrganizationAuthForm";
import styled from "styled-components";
import CloseButton from '../../../../components/Buttons/CloseButton/CloseButton';

function PatientLogInPage(props) {
    // hooks
    const {request} = useHttp()
    const baseURL = process.env.REACT_APP_BASE_URL
    const {login} = useContext(AuthContext)
    const {validateEmail, validatePassword} = validator()
    // state
    const [form, setForm] = useState({phone: '', password: ''})
    const [status, setStatus] = useState(0)
    //validation
    const validEmail = validateEmail(form.email)
    const validPassword = validatePassword(form.password)
    //Валидация и проверка на желание пользователя сохранаить сессию.
    const logIn = data => {
        // if (validEmail && validPassword) {
        if (data) {
            login(data.data)
        }
        //}
    }
    // Запрос
    const siginIn = async (event) => {
        event.preventDefault()
        try {
            const {data, status} = await request(`${baseURL}/api/v2/patients/login/`, 'POST', form, {})
            setStatus(status)
            logIn(data)
        } catch
            (e) {

        }
    }

    const setPhone = (e) => {
        setForm({
            phone: e.target.value,
            password: form.password
        })
    }
    const setPassword = (e) => {
        setForm({
            phone: form.phone,
            password: e.target.value
        })
    }
    const [auth, changeAuth] = useState(true)
    return (
        <>
            <img src="./img.png" className={'auth__background'} alt="background"/>

            <Modal styles={{top: 0}}>
                <div className="formModal">
                    <div onClick={()=>{window.location.href = '/'}} style={{position: 'absolute',width: '100%', height: '100%'}} />
                    <div className="auth__form">
                    <CloseButton onClick={_=>{window.location.href = '/'}}/>

                        <div className="auth__title">Вход</div>

                        <div className="auth-choose">
                            <div>
                                <input defaultChecked={true} onChange={() => {
                                    changeAuth(true)
                                }} id="doctor-auth" type="radio" name="auth"/>
                                <label htmlFor="doctor-auth">Пациент
                                    <div className="label__line "/>
                                </label>
                            </div>

                            <div>
                                <input onChange={() => {
                                    changeAuth(false)
                                }} id="organization-auth" type="radio" name="auth"/>
                                <label htmlFor="organization-auth">Организация
                                    <div className="label__line "/>
                                </label>
                            </div>
                        </div>


                        {auth ? <form key={'patinetLogin'} onSubmit={siginIn}
                                      className="auth__login-form auth__client__login-form">

                            <AttentionWrapper>

                                {props.attention ? <div className='qrAttention'>
                                    Результат могут посмотреть только авторизованные пользователи
                                </div> : ''}

                                {status === 401 ? <div className='qrAttention'>
                                    Неверный пароль
                                </div> : ''}

                                {status === 400 ? <div className='qrAttention'>
                                    Пользователь не найден
                                </div> : ''}

                                {status && status !== 200 && status !== 400 && status !== 401 ? <div className='qrAttention'>
                                    Неизвестная ошибка
                                </div> : ''}

                            </AttentionWrapper>

                            <FormInput
                                hideIcon
                                useNumberFormat={true}
                                name={'phone'}
                                keyss={'phone'}
                                format="+7(###)###-##-##"
                                allowEmptyFormatting={true}
                                type={'tel'}
                                onChange={setPhone}
                                mask={'_'}>
                                Номер телефона
                            </FormInput>

                            <FormInput
                                hideIcon
                                id='password'
                                title="Пароль"
                                name='password'
                                type='password'
                                onChange={setPassword}
                                attentionText='Неверный пароль'
                                showAttention={false}
                                icon={validPassword}
                            />

                            <div style={{marginTop: '0', marginBottom: '20px'}} className="form__options">
                                <div>
								{/*
                                    <Link to={process.env.REACT_APP_URL_PREFIX + "/restore/patient"}>
                                        <div className="restore-password">Забыли пароль?</div>
                                    </Link>
								*/}<br/>
                                </div>
                            </div>

                            <div className="form-buttons">

                                <button
                                    style={{marginRight: '10px'}}
                                    className="sign-in__button"
                                    type="submit">
                                    Войти
                                </button>

                                {/*<Link to={process.env.REACT_APP_URL_PREFIX + '/signIn'}>
                                    <button className="sign-up__button">Зарегистрироваться</button>
                                </Link>*/}
                            </div>

                        </form> : <OrganizationAuthForm/>}
                    </div>
                </div>
            </Modal>
        </>

    )
}

const AttentionWrapper = styled.div`
  min-height: 55px;
  width: 100%;
  margin-bottom: 10px;
`
export default PatientLogInPage
